<!-- ================用户端-营在规划-研学活动详情====================-->
<template>
    <div class="excursion-info-page">
        <home-head />
        <div class="excursion-info-body">
            <div class="excursion-info-inner">
                <!-- 顶部标题栏 -->
                <div class="excursion-info-header">
                    <div class="back-btn" @click="goBack">
                        <span class="back-arrow">←</span>
                        <span>返回</span>
                    </div>
                    <div class="excursion-info-title">{{ form.excursionTitle || '详情' }}</div>
                    <div class="excursion-info-actions">
                        <div class="action-btn" :class="{ active: isFavorite }" @click="handleFavorite" title="收藏">
                            <svg viewBox="0 0 1024 1024" width="22" height="22">
                                <path d="M512 0l127.4 395.6H1024L639.3 640.4 766.7 1024 512 779.6 257.3 1024l127.4-383.6L0 395.6h384.6z" fill="currentColor"/>
                            </svg>
                        </div>
                        <div class="action-btn" :class="{ active: isLike }" @click="handleLike" title="点赞">
                            <svg viewBox="0 0 1024 1024" width="22" height="22">
                                <path d="M884.2 396.6c-18.4-22.9-46.5-36.6-76.7-36.6h-188l21.6-117.8c8.6-46.8-3.8-95.4-34-132.4-28.2-34.6-69.8-54.4-113.8-54.4-54.2 0-102.8 31.4-125.6 80.4L299.6 270.2c-10.2 22.6-12.4 48.2-6.2 72.4l35.8 142.2H180.8c-56.8 0-102.8 46-102.8 102.8v281.2c0 56.8 46 102.8 102.8 102.8h532.4c48.2 0 90.8-31.8 104.4-78.4l102.6-360.6c12.6-44.2-1.6-91.8-34.6-124.6zM235.2 868.6h-54.4v-281.2h54.4v281.2z" fill="currentColor"/>
                            </svg>
                        </div>
                    </div>
                </div>

                <!-- 主内容区 -->
                <div class="excursion-info-main" v-loading="loading">
                    <!-- 一、活动基本信息 -->
                    <div class="info-section-title">一、活动基本信息</div>
                    <div class="info-line">
                        <span class="line-label">1.活动主题：</span>{{ form.excursionTheme || '--' }}
                    </div>
                    <div class="info-line">
                        <span class="line-label">2.参与对象：</span>{{ form.excursionAudienceName || '--' }} 学生
                    </div>
                    <div class="info-line">
                        <span class="line-label">3.活动时间：</span>{{ formatTimeRange() }}
                    </div>
                    <div class="info-line">
                        <span class="line-label">4.活动地点：</span>{{ form.excursionAddress || '--' }}
                    </div>
                    <!-- <div class="info-line">
                        <span class="line-label">5.活动时长：</span>{{ formatDuration() }}
                    </div> -->

                    <!-- 二、研学核心内容 -->
                    <div class="info-section-title">二、研学核心内容</div>
                    <div class="info-line">
                        <span class="line-label">1.知识研学：</span>{{ form.knowledgeExcursion || '--' }}
                    </div>
                    <div class="info-line">
                        <span class="line-label">2.实践体验：</span>{{ form.practicalExperience || '--' }}
                    </div>
                    <div class="info-line">
                        <span class="line-label">3.素养提升：</span>{{ form.qualityImprove || '--' }}
                    </div>
                    <div class="info-line">
                        <span class="line-label">4.安全保障：</span>{{ form.safetyAssurance || '--' }}
                    </div>

                    <!-- 三、活动介绍 -->
                    <div class="info-section-title">三、活动介绍</div>
                    <div class="excursion-overview" v-html="form.excursionOverview"></div>

                    <!-- 四、研学手册 -->
                    <div class="info-section-title">四、研学手册</div>
                    <div class="file-list" v-if="fileList.length > 0">
                        <div class="file-item" v-for="(item, index) in fileList" :key="index">
                            <div class="file-name" @click="downloadFile(item)">{{ item.fileName }}</div>
                            <div class="file-actions">
                                <div class="file-action" title="预览" v-if="item.imgUrl">
                                    <el-image @click="handleFileStatus(item.status)" class="file-icon"
                                              :src="require('@/assets/file/file_view_b22222.png')"
                                              :preview-src-list="gainFileImgList(item.imgUrl, item.pages)">
                                    </el-image>
                                </div>
                                <div class="file-action" title="下载" @click="downloadFile(item)">
                                    <img class="file-icon" src="@/assets/file/file_download_b22222.png" alt="下载" />
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="no-file" v-else>暂无附件</div>

                    <!-- 五、联系方式 -->
                    <template v-if="form.contactInfo">
                        <div class="info-section-title">五、联系方式</div>
                        <div class="info-line" style="white-space: pre-wrap;">{{ form.contactInfo }}</div>
                    </template>

                    <!-- 底部占位，避免内容贴合浏览器底边 -->
                    <div class="bottom-spacer"></div>
                </div>
                
            </div>
        </div>
    </div>
</template>

<script>
import { infoExcursion } from "@/api/admin/excursion";
import { addOrCancelCollect, judgeIsCollect } from "@/api/admin/collect";
import { addOrCancelLike, judgeIsLike } from "@/api/admin/likes";
import { timestampDate2 } from "@/utils/date";
import { downloadFile } from "@/utils/download";
import homeHead from "@/components/common/homeHead.vue";

export default {
    components: { homeHead },
    name: "excursionInfo",
    data() {
        return {
            loading: true,
            excursionId: '',
            form: {},
            fileList: [],
            isFavorite: false,
            isLike: false,
        }
    },
    computed: {},
    watch: {},
    created() {
        if (this.$route.query.excursionId) {
            this.excursionId = this.$route.query.excursionId;
            this.queryExcursionInfo();
            this.judgeLikeStatus();
        }
    },
    mounted() {},
    methods: {
        /* ===============查询研学活动详情===================== */
        queryExcursionInfo() {
            infoExcursion({ excursionId: this.excursionId }).then(res => {
                this.loading = false;
                if (res.data.code === 1) {
                    this.form = res.data.data || {};
                    this.judgeCollectStatus();
                    this.fileList = [];
                    if (this.form.fileList && this.form.fileList.length > 0) {
                        this.fileList = this.form.fileList;
                    } else if (this.form.fileUrls) {
                        this.form.fileUrls.split(',').forEach(e => {
                            this.fileList.push({
                                fileName: e.substring(e.lastIndexOf('/') + 1),
                                fileUrl: e,
                            })
                        })
                    }
                } else {
                    this.$message.error(res.data.msg || "操作失败");
                }
            }).catch(() => {
                this.loading = false;
            });
        },
        /* ===============返回===================== */
        goBack() {
            this.$router.go(-1);
        },
        /* ===============收藏/点赞===================== */
        judgeCollectStatus() {
            if (!this.form.campKey) return;
            judgeIsCollect({
                relationId: this.excursionId,
                collectType: Number(this.form.campKey),
                businessType: 7
            }).then(res => {
                if (res.data.code === 1) {
                    this.isFavorite = !!res.data.data;
                }
            });
        },
        judgeLikeStatus() {
            judgeIsLike({ relationId: this.excursionId }).then(res => {
                if (res.data.code === 1) {
                    this.isLike = !!res.data.data;
                }
            });
        },
        handleFavorite() {
            if (!this.form.campKey) {
                this.$message.warning("数据加载中，请稍后操作");
                return;
            }
            addOrCancelCollect({
                relationId: this.excursionId,
                collectType: Number(this.form.campKey),
                businessType: 7
            }).then(res => {
                if (res.data.code === 1) {
                    this.isFavorite = !this.isFavorite;
                    this.$message.success(this.isFavorite ? "收藏成功" : "已取消收藏");
                } else {
                    this.$message.error(res.data.msg || "操作失败");
                }
            });
        },
        handleLike() {
            addOrCancelLike({ relationId: this.excursionId }).then(res => {
                if (res.data.code === 1) {
                    this.isLike = !this.isLike;
                    this.$message.success(this.isLike ? "点赞成功" : "已取消点赞");
                } else {
                    this.$message.error(res.data.msg || "操作失败");
                }
            });
        },
        /* ===============工具方法===================== */
        formatTimeRange() {
            const begin = this.form.beginTime ? timestampDate2(Number(this.form.beginTime)) : '';
            const end = this.form.endTime ? timestampDate2(Number(this.form.endTime)) : '';
            if (begin && end) return begin + '--' + end;
            return begin || end || '--';
        },
        formatDuration() {
            if (!this.form.beginTime || !this.form.endTime) return '--';
            const diff = Number(this.form.endTime) - Number(this.form.beginTime);
            if (diff <= 0) return '--';
            const hours = Math.round(diff / 3600000);
            const days = Math.round(diff / 86400000 * 10) / 10;
            return hours + '小时 / ' + days + '天';
        },
        /* ===============文件操作===================== */
        downloadFile(item) {
            downloadFile(item.fileUrl, item.fileName);
        },
        handleFileStatus(status) {
            if (status === 1) {
            } else {
                this.$message.info("文件正在处理，请稍后刷新预览")
            }
        },
        gainFileImgList(baseUrl, page) {
            const list = [];
            for (let i = 1; i <= page; i++) {
                list.push(baseUrl + '/' + i + '.png');
            }
            return list;
        },
    }
}
</script>

<style scoped>
.excursion-info-page {
    width: 100%;
    height: 100vh;
    display: flex;
    flex-direction: column;
    overflow: hidden;
    background-color: #fdfcf8;
}

.excursion-info-body {
    flex: 1;
    min-height: 0;
    width: 100%;
    display: flex;
    justify-content: center;
    padding: 24px 0 0 0;
    box-sizing: border-box;
    overflow-y: auto;
    overflow-x: hidden;
}

.excursion-info-body::-webkit-scrollbar {
    width: 10px;
    height: 10px;
}

.excursion-info-body::-webkit-scrollbar-track {
    background: #f1f1f1;
    border-radius: 6px;
}

.excursion-info-body::-webkit-scrollbar-thumb {
    background: #b22222;
    border-radius: 6px;
    border: 3px solid #f1f1f1;
}

.excursion-info-body::-webkit-scrollbar-thumb:hover {
    background: #9a9a9a;
}

.excursion-info-inner {
    width: 100%;
    max-width: 1200px;
    margin: 0 auto;
    padding: 0 20px;
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
}

.bottom-spacer {
    width: 100%;
    height: 30px;
    flex-shrink: 0;
}

/* 顶部标题栏 */
.excursion-info-header {
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
    position: relative;
    margin-bottom: 24px;
    flex-shrink: 0;
}

.back-btn {
    height: 34px;
    line-height: 34px;
    padding: 0 20px;
    background-color: #b22222;
    color: #ffffff;
    border-radius: 4px;
    font-size: 14px;
    font-family: sans-serif;
    cursor: pointer;
    display: flex;
    align-items: center;
    transition: all 0.2s ease;
    z-index: 1;
}

.back-btn:hover {
    background-color: #9a1b1b;
}

.back-arrow {
    margin-right: 6px;
    font-size: 15px;
}

.excursion-info-title {
    position: absolute;
    left: 0;
    right: 0;
    text-align: center;
    font-size: 24px;
    color: #b22222;
    font-weight: bold;
    font-family: sans-serif;
    letter-spacing: 2px;
    pointer-events: none;
    padding: 0 120px;
    box-sizing: border-box;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}

.excursion-info-actions {
    display: flex;
    align-items: center;
    gap: 16px;
    z-index: 1;
}

.action-btn {
    width: 34px;
    height: 34px;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #9ca3af;
    cursor: pointer;
    transition: all 0.2s ease;
}

.action-btn:hover {
    color: #b22222;
}

.action-btn.active {
    color: #b22222;
}

/* 主内容区 */
.excursion-info-main {
    width: 100%;
    max-width: 900px;
    margin: 0 auto;
    min-height: 300px;
}

.info-section-title {
    font-size: 18px;
    font-weight: bold;
    color: #b22222;
    font-family: sans-serif;
    letter-spacing: 1px;
    margin: 24px 0 14px 0;
}

.info-section-title:first-child {
    margin-top: 0;
}

.info-line {
    width: 100%;
    font-size: 15px;
    color: #1f2937;
    font-family: sans-serif;
    line-height: 1.8;
    margin-bottom: 8px;
    padding-left: 20px;
    box-sizing: border-box;
}

.line-label {
    font-weight: bold;
    color: #1f2937;
}

.excursion-overview {
    width: 100%;
    font-size: 15px;
    color: #1f2937;
    line-height: 1.8;
    padding-left: 20px;
    box-sizing: border-box;
}

.excursion-overview img {
    max-width: 100%;
}

.excursion-overview table {
    width: 100%;
    border-collapse: collapse;
}

/* 研学手册 */
.file-list {
    width: 100%;
    padding-left: 20px;
    box-sizing: border-box;
}

.file-item {
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 10px 0;
    border-bottom: 1px solid #b22222;
    box-sizing: border-box;
}

.file-name {
    font-size: 15px;
    font-weight: bold;
    color: #1f2937;
    font-family: sans-serif;
    cursor: pointer;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}

.file-name:hover {
    color: #b22222;
}

.file-actions {
    display: flex;
    align-items: center;
    gap: 14px;
    flex-shrink: 0;
}

.file-action {
    width: 24px;
    height: 24px;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
}

.file-icon {
    width: 20px;
    height: 20px;
}

.no-file {
    width: 100%;
    font-size: 14px;
    color: #9ca3af;
    font-family: sans-serif;
    padding-left: 20px;
    box-sizing: border-box;
}

@media (max-width: 768px) {
    .excursion-info-header { flex-wrap: wrap; gap: 10px; }
    .excursion-info-title { position: static; order: 3; width: 100%; padding: 0; font-size: 20px; }
    .info-line { padding-left: 0; }
    .file-list { padding-left: 0; }
    .excursion-overview { padding-left: 0; }
}
</style>
